import { Component, OnInit, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BeginTourComponent } from './dialogs/begin-tour/begin-tour.component';
import { G2mTourComponent } from './dialogs/g2m-tour/g2m-tour.component';

@Component({
  selector: 'customer-app-first-visit-experience',
  templateUrl: './first-visit-experience.component.html',
  styleUrls: ['./first-visit-experience.component.scss'],
  standalone: false
})
export class FirstVisitExperienceComponent implements OnInit {
  private dialog = inject(MatDialog);

  readonly G2M = input(false);

  ngOnInit(): void {
    if (this.G2M()) {
      this.dialog.open(G2mTourComponent, {
        backdropClass: 'backdrop-hide-remove',
        maxHeight: '90vh',
        maxWidth: '90vw',
        panelClass: ['close-icon-and-transition'],
        disableClose: true
      });
    } else {
      this.dialog.open(BeginTourComponent, {
        backdropClass: 'backdrop-hide-remove',
        maxHeight: '90vh',
        maxWidth: '90vw',
        panelClass: ['close-icon-and-transition'],
        disableClose: true
      });
    }
  }
}
